import { createFileRoute, redirect } from "@tanstack/react-router";
import { routeHead } from "@/lib/seo/route-head";

export const Route = createFileRoute("/mercedes-benz-second-hand-romania/")({
  head: () => routeHead("/mercedes-benz-second-hand-romania/"),
  beforeLoad: () => {
    throw redirect({ href: "/cars/mercedes-benz", statusCode: 301, replace: true });
  },
});
